import type { CheckoutCountry } from '@/components/BillingCheckoutForm.vue'

/**
 * The countries the first checkout offers (os#1615), by ISO 3166-1 alpha-2 code, sorted by name. FloPay checks the tax
 * ID's format, so the portal only decides whether to ask for one.
 */
export const BILLING_COUNTRIES: readonly CheckoutCountry[] = [
    { code: 'AU', name: 'Australia' },
    { code: 'AT', name: 'Austria' },
    { code: 'BE', name: 'Belgium' },
    { code: 'BR', name: 'Brazil' },
    { code: 'CA', name: 'Canada' },
    { code: 'CZ', name: 'Czechia' },
    { code: 'DK', name: 'Denmark' },
    { code: 'FI', name: 'Finland' },
    { code: 'FR', name: 'France' },
    { code: 'DE', name: 'Germany' },
    { code: 'GR', name: 'Greece' },
    { code: 'HK', name: 'Hong Kong' },
    { code: 'IN', name: 'India' },
    { code: 'IE', name: 'Ireland' },
    { code: 'IL', name: 'Israel' },
    { code: 'IT', name: 'Italy' },
    { code: 'JP', name: 'Japan' },
    { code: 'LU', name: 'Luxembourg' },
    { code: 'MX', name: 'Mexico' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'NO', name: 'Norway' },
    { code: 'PL', name: 'Poland' },
    { code: 'PT', name: 'Portugal' },
    { code: 'SG', name: 'Singapore' },
    { code: 'ZA', name: 'South Africa' },
    { code: 'ES', name: 'Spain' },
    { code: 'SE', name: 'Sweden' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'AE', name: 'United Arab Emirates' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'US', name: 'United States' },
]

/**
 * The countries above with a business tax ID (VAT, GST, ABN, …), which is when the checkout shows the tax ID field.
 * It stays optional there: a business under its country's threshold has none. Hong Kong and the United States have no
 * national business tax ID the invoice carries.
 */
export const TAX_ID_COUNTRIES: readonly string[] = BILLING_COUNTRIES.map(country => country.code).filter(
    code => code !== 'HK' && code !== 'US',
)
